import React from "react";
import c from "lib/style/colorVar.scss";

/**
 * @typedef {Object} ColorVar
 * @property {string} brand1
 * @property {string} brandBluegrey3
 * @property {string} brandBluegrey2
 * @property {string} brandBluegrey1
 * @property {string} brandBluegreyLight
 * @property {string} brandLight25
 * @property {string} brandLight35
 * @property {string} brandLight50
 * @property {string} brandLight64
 * @property {string} brandLight75
 * @property {string} brandLight85
 * @property {string} brandLight92
 * @property {string} brandDark12
 * @property {string} brandDark25
 * @property {string} brandDark35
 * @property {string} brandDark50
 * @property {string} brandDark64
 * @property {string} brandDark75
 * @property {string} yellow
 * @property {string} yellowHover
 * @property {string} yellowWordings
 * @property {string} black
 * @property {string} blackDark666
 * @property {string} blackDark999
 * @property {string} blackDarkAAA
 * @property {string} blackLightCCC
 * @property {string} blackLightDDD
 * @property {string} greyLightEEE
 * @property {string} greyLightF0BG
 * @property {string} greyLightF6
 * @property {string} greyLightFA
 * @property {string} greyLightFFF
 * @property {string} success
 * @property {string} successLight
 * @property {string} successBg
 * @property {string} warning
 * @property {string} warningDark
 * @property {string} warningLight
 * @property {string} warningBg
 * @property {string} disabledFieldBg
 * @property {string} danger
 * @property {string} dangerDark
 * @property {string} dangerLight
 * @property {string} dangerBg
 * @property {string} chartColor1
 * @property {string} chartColor2
 * @property {string} chartColor3
 * @property {string} chartColor4
 * @property {string} chartColor5
 * @property {string} chartColor6
 * @property {string} chartColor7
 * @property {string} chartColor8
 * @property {string[]} chartColorArray
 */

/**
 * Custom hook for accessing color variables
 * @returns {ColorVar}
 */
const useColors = () => {
  const chartColorArray = [
    c["chartColor1"],
    c["chartColor2"],
    c["chartColor3"],
    c["chartColor4"],
    c["chartColor5"],
    c["chartColor6"],
    c["chartColor7"],
    c["chartColor8"],
    c["chartColor9"],
  ];
  return React.useMemo(() => ({ chartColorArray, ...c }), []);
};

export default useColors;
